module.exports = __webpack_public_path__ + "static/woman-in-chair-fdaaa45464eac19b5c6df3050b1edaa6.png";